"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedUserAssignments = void 0;
var getGroupUserAssignments = function (group) {
    return (group === null || group === void 0 ? void 0 : group.id) !== undefined
        ? ((group === null || group === void 0 ? void 0 : group.members) || []).map(function (user) { return ({
            userUuid: user.uuid,
            groupId: group.id
        }); })
        : [];
};
var getCategoryUserAssignments = function (category) {
    var _a, _b;
    var members = ((_a = category === null || category === void 0 ? void 0 : category.category) === null || _a === void 0 ? void 0 : _a.members) || [];
    var memberAssignments = members.map(function (user) { return ({
        userUuid: user.uuid,
        groupId: category.category.id
    }); });
    var groupMemberAssignments = ((_b = category.groups) !== null && _b !== void 0 ? _b : []).reduce(function (acc, group) {
        return (acc = __spreadArray(__spreadArray([], acc, true), getGroupUserAssignments(group), true));
    }, []);
    return __spreadArray(__spreadArray([], memberAssignments, true), groupMemberAssignments, true);
};
var getUserAssignments = function (groups) {
    return groups.reduce(function (acc, group) {
        return (acc = __spreadArray(__spreadArray([], acc, true), getCategoryUserAssignments(group), true));
    }, []);
};
var getSelectedUserAssignments = function (groups, selectedUuids) {
    return getUserAssignments(groups).filter(function (assignment) {
        return selectedUuids.includes(assignment.userUuid);
    });
};
exports.getSelectedUserAssignments = getSelectedUserAssignments;
